import { ContainerPlaceholder } from './styles';

const MovieBannerPlaceholder = (): JSX.Element => {
  return <ContainerPlaceholder />;
};

export default MovieBannerPlaceholder;
